import { Grid, Typography, Button } from "@material-ui/core"
import Dropzone from 'react-dropzone'

export const ICON_SIZE = 20000000 // Tamaño de las imagenes en bytes
export const ACCEPTED_FORMATS = ['.pdf'] // formato de las imagenes de subdominio

export const ConfirmationMessage = ({ cancelFileUpload, pdfFileUrlPresigned, temporalFile }) => {
   return (
      <Grid
         container
         direction="column"
         style={{
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 10
         }}
      >
         <Typography style={{ width: '400px' }} variant="subtitle1">
            ¿Desea cargar el PDF {temporalFile[0].name} ?
         </Typography>

         <Grid
            item
            container
            spacing={10}
            style={{
               justifyContent: 'center',
               alignItems: 'center',
               marginTop: 10
            }}
         >
            <Button
               variant="outlined"
               color="primary"
               style={{ marginRight: 30, width: '158px' }}
               onClick={cancelFileUpload}
            >
               Cancelar
            </Button>
            <Button
               variant="contained"
               color="primary"
               style={{ width: '158px' }}
               onClick={() => pdfFileUrlPresigned()}
            >
               Aceptar
            </Button>
         </Grid>
      </Grid>
   )
}

export const UploadManualMessage = ({ classes, iconConfirm, onAction, handleFileAdd }) => {
   return (
      <Grid
         container
         direction="column"
         style={{
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 10,
            zIndex: 50
         }}
      >
         {!iconConfirm && (
            <Typography style={{ minWidth: '400px' }} variant="subtitle1">
               <span className={classes.spanTitleIcon}>Arrastra y suelta o carga tu archivo .pdf desde tu equipo.</span>
               <Dropzone
                  onDrop={(acceptedFiles, fileRejections) => handleFileAdd(acceptedFiles, fileRejections)}
                  maxFiles={1}
                  accept={ACCEPTED_FORMATS}
                  maxSize={ICON_SIZE}
               >
                  {({ getRootProps, getInputProps }) => (
                     <div style={{ display: 'inline' }} {...getRootProps()}>
                        <input {...getInputProps()} />
                        <span className={classes.spanIconClick}>o haga click</span>
                     </div>
                  )}
               </Dropzone>{' '}
               para seleccionarlo desde su equipo.
            </Typography>
         )}

         {iconConfirm && (
            <>
               <Typography variant="subtitle1">¡PDF cargado con éxito!</Typography>
               <Grid
                  item
                  container
                  spacing={10}
                  style={{
                     justifyContent: 'center',
                     alignItems: 'center',
                     marginTop: 10
                  }}
               >
                  <Button variant="contained" color="primary" onClick={onAction}>
                     Aceptar
                  </Button>
               </Grid>
            </>
         )}
      </Grid>
   )
}